export default __webpack_public_path__ + "static/media/tick.e841a29c.svg";